import React, {useImperativeHandle, forwardRef, useEffect} from 'react';
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  withTiming,
  withSequence,
} from 'react-native-reanimated';
import {RFValue} from 'react-native-responsive-fontsize';
import {Vibration} from 'react-native';
import { useTheme } from 'styled-components/native';

export interface AnimatedTitleHandle {
  shake: () => void;
}

const AnimatedTitle = forwardRef<AnimatedTitleHandle, React.PropsWithChildren>(
  ({children}, ref) => {
    const theme = useTheme();
    const backgroundColor = useSharedValue<string>('transparent');
    const textColor = useSharedValue<string>(theme.colors.title);
    const translateX = useSharedValue<number>(0);

    const handleShake = () => {
      backgroundColor.value = withTiming(theme.colors.purple_2_gradient[0], {
        duration: 300,
      });
      textColor.value = withTiming(theme.colors.silver_text, {duration: 300});

      translateX.value = withSequence(
        withTiming(-10, {duration: 50}),
        withTiming(10, {duration: 50}),
        withTiming(-10, {duration: 50}),
        withTiming(10, {duration: 50}),
        withTiming(0, {duration: 50}),
      );

      setTimeout(() => {
        backgroundColor.value = withTiming('transparent', {duration: 300});
        textColor.value = withTiming(theme.colors.title, {duration: 300});
      }, 1000);

      Vibration.vibrate(50);
    };

    useImperativeHandle(ref, () => ({
      shake: handleShake,
    }));

    useEffect(() => {
      // Atualiza as cores ao mudar o tema
      backgroundColor.value = withTiming('transparent', {duration: 300});
      textColor.value = withTiming(theme.colors.title, {duration: 300});
    }, [theme.colors.title]);

    const animatedContainer = useAnimatedStyle(() => ({
      backgroundColor: backgroundColor.value,
      transform: [{translateX: translateX.value}],
    }));

    const animatedText = useAnimatedStyle(() => ({
      color: textColor.value,
    }));

    return (
      <Animated.View
        style={[
          {
            borderRadius: 8,
            paddingHorizontal: 6,
          },
          animatedContainer,
        ]}>
        <Animated.Text
          style={[
            {
              fontSize: RFValue(14),
              fontFamily: 'Poppins-SemiBold',
              color: theme.colors.title, // cor padrão, usada caso animação não rode
            },
            animatedText,
          ]}>
          {children}
        </Animated.Text>
      </Animated.View>
    );
  },
);

export default AnimatedTitle;
